import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — decor: a small houseplant at true metric size (~0.6 m
// tall). Terracotta pot, soil disc, a thin stem carrying leaf-green clumps.
const POT = "#a05a40";
const SOIL = "#4a3a2a";
const STEM = "#4a6e3a";
const LEAF = "#5f8f4e";
const LEAF_LIGHT = "#6f9f5c";

export const pottedPlant = defineModel({
  id: "potted-plant",
  batchId: "modern",
  name: "Potted plant",
  tags: ["modern", "interior", "decor", "plant", "houseplant"],
  summary: "A small houseplant in a terracotta pot.",
  tiles: { w: 1, h: 1 },
  footprint: 0.4,
  parts(): Part[] {
    return [
      // tapered terracotta pot
      { geometry: new THREE.CylinderGeometry(0.11, 0.08, 0.16, 10), color: POT, position: [0, 0.08, 0] },
      // soil disc
      { geometry: new THREE.CylinderGeometry(0.095, 0.095, 0.02, 10), color: SOIL, position: [0, 0.155, 0] },
      // thin stem
      { geometry: new THREE.CylinderGeometry(0.012, 0.014, 0.28, 6), color: STEM, position: [0, 0.3, 0] },
      // leaf clumps
      { geometry: new THREE.IcosahedronGeometry(0.13, 0), color: LEAF, position: [0, 0.5, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.1, 0), color: LEAF_LIGHT, position: [0.09, 0.4, 0.04] },
      { geometry: new THREE.IcosahedronGeometry(0.09, 0), color: LEAF, position: [-0.08, 0.42, -0.05] },
    ];
  },
  animations: [],
});
